module.exports = __webpack_public_path__ + "img/xmxx.2e7f9c78.jpg";